module.exports = __webpack_public_path__ + "static/media/profile-frame-v3-resized.a3ac6e23.png";